import React from 'react';
import { useTranslation } from 'react-i18next';

const BenefitsSection = () => {
  const { t } = useTranslation('lip-filler');
  const benefits = [
    {
      title: t('benefits.items.0.title'),
      description: t('benefits.items.0.description'),
      color: "bg-dental-coral"
    },
    {
      title: t('benefits.items.1.title'),
      description: t('benefits.items.1.description'),
      color: "bg-dental"
    },
    {
      title: t('benefits.items.2.title'),
      description: t('benefits.items.2.description'),
      color: "bg-dental-mint"
    },
    {
      title: t('benefits.items.3.title'),
      description: t('benefits.items.3.description'),
      color: "bg-dental-purple"
    },
    {
      title: t('benefits.items.4.title'),
      description: t('benefits.items.4.description'),
      color: "bg-dental-coral"
    },
    {
      title: t('benefits.items.5.title'),
      description: t('benefits.items.5.description'),
      color: "bg-dental"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-6 reveal">
            {t('benefits.headingPrefix')} <span className="text-dental-coral">{t('benefits.headingAccent')}</span>
          </h2>
          <p className="text-lg text-dental-dark/80 reveal" data-delay="0.1">
            {t('benefits.intro')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300 reveal"
              data-delay={index * 0.1}
            >
              <div className={`w-12 h-1 ${benefit.color} mb-6 rounded-full`}></div>
              <h3 className="text-xl font-bold mb-3">{benefit.title}</h3>
              <p className="text-dental-dark/80">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
